class MobileNav extends HTMLElement {
  constructor() {
    super()
    this.button = null
    this.nav = null
  }

  connectedCallback() {
    // Get references to elements
    this.parent = this.closest('header')
    this.button = this.querySelector('button')
    this.nav = this.querySelector('nav')

    if (this.button && this.nav) {
      // Set initial state
      this.button.setAttribute('aria-expanded', 'false')
      this.nav.classList.add('hidden')

      // Add click handler
      this.button.addEventListener('click', () => this.toggleMenu())
    }
  }

  toggleMenu() {
    const isExpanded = this.button.getAttribute('aria-expanded') === 'true'
    this.button.setAttribute('aria-expanded', (!isExpanded).toString())
    this.nav.classList.toggle('hidden')
    this.parent.classList.toggle('not-homepage:bg-black')
    this.parent.classList.toggle('homepage:fold-50:bg-black')
  }
}

// Register the component
customElements.define('mobile-nav', MobileNav) 